export default __webpack_public_path__ + "static/media/Frictionless Login.6fa1f80b.svg";